module.exports = __webpack_public_path__ + "static/poster-aparima-5e2d8c036ea816f5299907f806f81367.jpg";